import { shallowEqual, useSelector } from 'react-redux';

import { BILLING_DATE_RANGE_PROPS } from './billing-filter-properties';
import ReportActions from '../../../report-actions';
import { EXPORT_CSV, EXPORT_PDF } from '../../../report-actions/constants';
import ReportFilters from '../../../report-filters';
import { buildDropdownOptions } from '../../../report-filters/filters/dropdown/helpers';

const actions = [EXPORT_PDF, EXPORT_CSV];
const filtersProps = [BILLING_DATE_RANGE_PROPS];

const BillingReports = () => {
  const updatedFiltersProps = useSelector((state) => buildDropdownOptions({ filtersProps, state }), shallowEqual);

  return (
    <>
      <ReportFilters filtersProps={updatedFiltersProps} />
      <ReportActions actions={actions} />
    </>
  );
};

export { BillingReports };
